const MAX_LENGTH = 50

// Windows extracts into a folder named after the zip, and that counts towards its 260-character path limit.
export function zipDownloadName(name) {
  const clean = String(name || '')
    // eslint-disable-next-line no-control-regex
    .replace(/[\\/:*?"<>|\x00-\x1F]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  const capped = Array.from(clean)
    .slice(0, MAX_LENGTH)
    .join('')
    .replace(/[\s._-]+$/, '')

  return `${capped || 'download'}.zip`
}
